export default __webpack_public_path__ + "static/media/create_dec2.8158764d.PNG";